// DataTableHeader.tsx

import { Box } from '@mui/material'
import React from 'react'
import { TableHeaderRowProps } from 'react-virtualized'

export default function TableHeader({ columns, style, ...props }: TableHeaderRowProps) {
  return (
    <Box
      sx={{
        ...style,
        fontWeight: '600',
        fontSize: '12px',
        lineHeight: '16px',
        textTransform: 'capitalize',
      }}
      {...props}
    >
      {columns}
    </Box>
  )
}
